var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('router-view',{attrs:{"link":_vm.link},on:{"updated":_vm.fetchData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }